export const REQUESTS_BUSINESS_TRIP_PATH = "/requests/business-trip";
